export const STRATEGY_KEYS: Record<string, string> = {
  'trend': 'trend',
  'trend following': 'trend',
  'trend_following': 'trend',
  'sma crossover': 'sma_crossover',
  'sma_crossover': 'sma_crossover',
  'macd': 'macd',
  'rsi': 'rsi',
  'scalping': 'scalping',
  'support/resistance': 'support_resistance',
  'support_resistance': 'support_resistance',
  'candle patterns': 'candle_patterns',
  'candle_patterns': 'candle_patterns',
  'swing': 'swing',
  'swing trading': 'swing',
  'chart patterns': 'chart_patterns',
  'chart_patterns': 'chart_patterns',
  'fvg': 'fvg',
  'fair value gap': 'fvg',
  'signal only': 'signal_only',
  'signal-only': 'signal_only',
  'signals': 'signal_only',
  'signal_only': 'signal_only',
};

export function toStrategyKey(input?: string | null): string | null {
  if (!input) return null;
  const s = String(input).trim().toLowerCase();
  return STRATEGY_KEYS[s] ?? null;
}
